type NavigatorCareStageCardProps = {
  eyebrow: string;
  careStageLabel: string;
  summaryBullets: string[];
  /** Warm one-liner shown when there are no summary bullets (guest / deep link). */
  fallbackLine?: string;
  /** Suppress the stage label when it would duplicate the page H1 above it. */
  hideLabel?: boolean;
};

export const NavigatorCareStageCard = ({
  eyebrow,
  careStageLabel,
  summaryBullets,
  fallbackLine,
  hideLabel = false,
}: NavigatorCareStageCardProps) => {
  const bodyText = summaryBullets.join(' ').trim() || fallbackLine?.trim() || '';
  // Without body copy the two-column grid leaves a floating divider and an
  // empty right half — collapse to a single centered column instead.
  const hasBody = Boolean(bodyText);

  return (
    <article className="rounded-2xl border border-border-subtle bg-card-base">
      <div
        className={`grid items-stretch ${
          hasBody ? 'md:grid-cols-[minmax(0,380px)_minmax(0,1fr)]' : ''
        }`}
      >
        <div
          className={`flex flex-col justify-center gap-2 px-8 py-6 ${
            hasBody ? 'md:border-r md:border-border-subtle' : ''
          }`}
        >
          <p className="text-[11px] font-bold uppercase tracking-[0.12em] text-sage">{eyebrow}</p>
          {!hideLabel && careStageLabel.trim() && (
            <h2 className="font-termina text-2xl font-medium leading-tight text-text-primary">
              {careStageLabel}
            </h2>
          )}
        </div>

        {hasBody && (
          <div className="px-8 py-6">
            <p className="text-base leading-relaxed text-text-primary">{bodyText}</p>
          </div>
        )}
      </div>
    </article>
  );
};
